import { App } from 'shared/types/App'

type AppHeaders = {
  app: App
  isClient: boolean
  token?: string
  /**
   * *namespace* is used to set the *x-goat-namespace* header for the request.
   *
   * The *x-goat-namespace* is a passthrough header that should only be included
   * if present in original request.
   */
  namespace?: string
}

/**
 * [appHeaders]
 * Determine app specific headers to return for communication with GOAT apps
 * Defaults requests to 'sneakers' app if not or incorrectly specified
 */
export const appHeaders = ({
  app,
  isClient,
  token,
  namespace,
}: AppHeaders): Record<string, string> => {
  // Namespaced stageX envs have requests with header "x-goat-namespace" : "stagex/web-fc-prXXXX".
  // The cms-service requires the header to be set to staging when the namespace is for a stageX env.
  const namespaceHeader = (() => {
    if (namespace && namespace.length > 0) {
      if (namespace.toLowerCase().includes('stagex')) {
        return { 'x-goat-namespace': 'staging' }
      }
      return { 'x-goat-namespace': namespace }
    } else {
      return undefined
    }
  })()

  switch (app) {
    case 'cms':
      return {
        'x-goat-app': 'cms-service',
        ...namespaceHeader,
      }
    case 'peas':
      return {
        'X-CSRF-TOKEN': token || '',
        'x-goat-app': 'payments-availability',
      }
    case 'product-template-lists': {
      if (isClient) {
        return {
          'X-CSRF-TOKEN': token || '',
          'x-goat-app': 'product-template-lists',
        }
      }
      return {
        Authorization: token ? `Token token="${token}"` : '',
        'x-goat-app': 'product-template-lists',
      }
    }
    case 'feature-flags':
      return {
        'X-CSRF-TOKEN': token || '',
      }
    default:
      if (isClient) {
        return {
          'X-CSRF-TOKEN': token || '',
          'x-goat-app': 'sneakers',
        }
      }
      return {
        Authorization: token ? `Token token="${token}"` : '',
        'x-goat-app': 'sneakers',
      }
  }
}
